import PushNotificationApi from "api/pushNotificationApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { putRedeemCode } from "store/redeemCode/thunk";

const SendStatusAction = ({
  idPushLog,
  triggerRefresh,
}: {
  idPushLog?: string;
  triggerRefresh?: any;
}) => {
  const { t, i18n } = useTranslation();

  const modalEl = useRef<HTMLDivElement>(null);
  const [dataId, setDataId] = useState<string>("");
  const [idxSendStatus, setIdxSendStatus] = useState<{
    index: string;
    active: boolean;
  }>({ index: "", active: false });

  const handleClickSendStatus = () => {
    setIdxSendStatus((pre: any) => ({ index: dataId, active: !pre?.active }));
  };

  const handleUpdateStatus = async () => {
    try {
      if (!idPushLog) {
        return;
      }
      const response: any = await putRedeemCode(idPushLog, {
        status: "canceled",
      });

      if (response?.statusCode === 200) {
        setIdxSendStatus({ index: "", active: false });
        triggerRefresh();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  useEffect(() => {
    if (idPushLog) {
      setDataId(idPushLog);
    }
  }, [idPushLog]);

  useEffect(() => {
    const handler = (event: any) => {
      if (!modalEl.current) {
        return;
      }

      if (!(modalEl?.current as any)?.contains(event.target)) {
        setIdxSendStatus({ index: "", active: false });
      }
    };

    document.addEventListener("click", handler, true);
    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);

  return (
    <div
      ref={modalEl}
      style={{
        maxHeight: "16px",
        right: i18n?.language === "en" ? "20px" : "10px",
        marginTop: -10,
      }}
      className=""
    >
      <div
        className="cursor-pointer d-contents"
        onClick={handleClickSendStatus}
      >
        {idxSendStatus?.active ? (
          <i className="ri-arrow-up-s-line text-primary fs-18"></i>
        ) : (
          <i className="ri-arrow-down-s-line fs-18"></i>
        )}
      </div>
      <div
        className={`collapse position-absolute text-danger text-decoration-underline ${
          idxSendStatus?.active === true && idxSendStatus?.index === idPushLog
            ? "show "
            : ""
        }`}
      >
        <div className="card card-body p-2 text-decor">
          <span
            onClick={handleUpdateStatus}
            className="cursor-pointer"
            style={{ whiteSpace: "nowrap" }}
          >
            {t("Cancel")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SendStatusAction;
